import Vue from 'vue'

export const tokenService = {
  refresh
}

function refresh () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/refresh-token'))
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/token.service.js